import { UserPlanType } from '../../../store/workspace/types';
import { ExtraServiceOption, PlansTab } from './types';

/** Landing page that hosts the "book a demo" form every contact-sales link opens. */
export const CONTACT_SALES_URL = `${process.env.REACT_APP_LANDING_URL}/book-demo`;

/** Plan tabs of the "Plan Information" section, in display order. */
export const PLANS_TABS: { id: PlansTab; title: string }[] = [
    { id: 'Current', title: 'Current plan' },
    { id: 'History', title: 'Plan’s history' },
];

/** A seat can never be bought beyond this total, sales has to be involved. */
export const MAX_MEMBER_SEATS = 5;

/** Unit prices of every extra service, per plan the account currently sits on. */
export const MEMBER_UNIT_PRICES: Record<UserPlanType, number> = {
    free_trial: 0,
    standard_monthly: 20,
    standard_annual: 16,
    professional_monthly: 20,
    professional_annual: 16,
};

export const JOB_POST_UNIT_PRICES: Record<UserPlanType, number> = {
    free_trial: 0,
    standard_monthly: 60,
    standard_annual: 50,
    professional_monthly: 44,
    professional_annual: 38,
};

export const APPLICANT_UNIT_PRICES: Record<UserPlanType, number> = {
    free_trial: 0,
    standard_monthly: 30,
    standard_annual: 30,
    professional_monthly: 28,
    professional_annual: 28,
};

/** Applicants bundled with every extra job post, per plan. */
export const APPLICANTS_PER_JOB_POST: Record<UserPlanType, number> = {
    free_trial: 0,
    standard_monthly: 50,
    standard_annual: 50,
    professional_monthly: 60,
    professional_annual: 60,
};

/** Plan used to price extra services while the profile is still loading. */
export const FALLBACK_PLAN_TYPE: UserPlanType = 'standard_monthly';

/** One to ten extra job posts, followed by the contact-sales escape hatch. */
export const JOB_POST_OPTIONS: ExtraServiceOption[] = [
    ...Array.from({ length: 10 }, (_, index) => ({
        id: index + 1,
        sub: index + 1,
        title: `${index + 1} Job post`,
    })),
    { id: 11, sub: 0, title: '+10 Job post', contactSales: true },
];

/** `sub` counts bundles of fifty applicants, which is what the API bills on. */
export const APPLICANT_OPTIONS: ExtraServiceOption[] = [
    { id: 1, sub: 1, title: '50 Applicants' },
    { id: 2, sub: 2, title: '100 Applicants' },
    { id: 3, sub: 4, title: '200 Applicants' },
    { id: 4, sub: 10, title: '500 Applicants' },
    { id: 5, sub: 20, title: '1000 Applicants' },
    { id: 6, sub: 0, title: '+1000 Applicants', contactSales: true },
];

/** Rules the new password is checked against, in the order they are listed. */
export const PASSWORD_RULES = [
    { key: 'num', text: 'It must contain at least one number' },
    { key: 'min', text: 'It must contain at least 8 characters' },
    { key: 'word', text: 'It must contain at least one capital and one small letter' },
    { key: 'char', text: 'It must contain at least one special character (!@#$%^&*)' },
    { key: 'match', text: 'The passwords must match' },
] as const;
